import React from 'react';
import Demo from '../Demo/Demo';
import { hero, trust } from '../Data/Data';
import './Hero.css';

const Hero = () => (
    <section className="hero" id="home">
        <div className="container hero-grid">
            <div className="hero-copy">
                <h1>{hero.title}</h1>
                <p className="lead">{hero.lead}</p>
                <div className="hero-actions">
                    <a href={hero.primary.href} className="btn btn-primary">{hero.primary.label}</a>
                    <a href={hero.secondary.href} className="btn btn-ghost">{hero.secondary.label}</a>
                </div>
                <p className="hero-origin">{hero.origin}</p>
            </div>
            <Demo demo={hero.demo} className="hero-demo" />
        </div>
        <div className="container">
            <div className="trust">
                <img src={trust.logo} alt={trust.logoAlt} width="160" height="55" />
                <p>{trust.text}</p>
            </div>
        </div>
    </section>
);

export default Hero;
